import { render, staticRenderFns } from "./JustificativaNaoVenda.vue?vue&type=template&id=2862af75&scoped=true"
import script from "./JustificativaNaoVenda.vue?vue&type=script&lang=js"
export * from "./JustificativaNaoVenda.vue?vue&type=script&lang=js"
import style0 from "./JustificativaNaoVenda.vue?vue&type=style&index=0&id=2862af75&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2862af75",
  null
  
)

export default component.exports